import { SplitBarCodeModel } from './../model/inspection.model';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { InspectionDetailList, InspectionSearch, GetInvoiceNo4IQCResult, InspectionTypeSearch, GetInspectionResultResult, InspectionH, SamplingSearch, InspectionD, InspectionEdit, InspectionHeaderList, GetSamplingDetail4SQEResult, InspectionItem4SQESearch, SQEInspectionH, GetInvoiceNo4SQEResult, FGInspectionModel, FGInspectionH, FGInspectionSearch, RepackingList, RepackingSearch, RepackingModel } from "../model/inspection.model";
import { ReturnApi } from "../model/common.model";


const API_URL = environment.apiUrl;
const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class InspctionService {
    private Url = '';  // URL to web api
    currentUser: any;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log(this.currentUser);
        this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/Inspection';

    }

    getInspectionList(search: InspectionSearch): Observable<InspectionDetailList[]> {
        return this.http.post<InspectionDetailList[]>(this.Url + "/GetIQCInspectionListResult", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetIQCInspectionHeaderList(search: InspectionSearch): Observable<InspectionHeaderList[]> {
        return this.http.post<InspectionHeaderList[]>(this.Url + "/GetIQCInspectionHeaderList", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetSQEInspectionForExport(search: InspectionSearch, type: number): Observable<any> {

        return this.http.post(this.Url + '/GetSQEInspectionListForExport/' + type, search, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',

            }),
            responseType: 'arraybuffer'
        }).pipe(tap((x) => {
        }),
            catchError(this.handleError<InspectionSearch>('SearchWorkPermit'))
        );
    }
    GetIQCInspectionForExport(search: InspectionSearch, type: number): Observable<any> {

        return this.http.post(this.Url + '/GetIQCInspectionListForExport/' + type, search, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',

            }),
            responseType: 'arraybuffer'
        }).pipe(tap((x) => {
        }),
            catchError(this.handleError<InspectionSearch>('SearchWorkPermit'))
        );
    }


    GetSQEInspectionHeaderList(search: InspectionSearch): Observable<InspectionHeaderList[]> {
        return this.http.post<InspectionHeaderList[]>(this.Url + "/GetSQEInspectionHeaderList", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    getInvoiceNoListByItemId_IQC(ItemId: number): Observable<GetInvoiceNo4IQCResult[]> {
        return this.http.get<GetInvoiceNo4IQCResult[]>(this.Url + "/GetInvoiceNo4IQC/" + ItemId.toString(), httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    getInvoiceNoListByItemId_SQE(ItemId: number): Observable<GetInvoiceNo4SQEResult[]> {
        return this.http.get<GetInvoiceNo4SQEResult[]>(this.Url + "/GetInvoiceNo4SQE/" + ItemId.toString(), httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    getInspectionByInspectionType(search: InspectionTypeSearch): Observable<GetInspectionResultResult[]> {
        return this.http.post<GetInspectionResultResult[]>(this.Url + "/GetInspectionResult", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetSamplingDetail(search: SamplingSearch): Observable<InspectionH[]> {
        return this.http.post<InspectionH[]>(this.Url + "/GetSamplingDetail4IQC", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetInspectionItem4SQE(search: InspectionItem4SQESearch): Observable<SQEInspectionH[]> {
        return this.http.post<SQEInspectionH[]>(this.Url + "/GetInvoiceNo4SQE", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetInspectionItem4Edit(search: InspectionEdit): Observable<any> {
        return this.http.post<any>(this.Url + "/GetInspectionItem4Edit", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetSQEInspectionItem4Edit(search: InspectionEdit): Observable<any> {
        return this.http.post<any>(this.Url + "/GetSQEInspectionItem4Edit", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    SaveInspection(item: InspectionH[]): Observable<ReturnApi> {
        return this.http.post<ReturnApi>(this.Url + "/SaveInspection", item, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    SaveInspection_SQE(item: SQEInspectionH[]): Observable<ReturnApi> {
        return this.http.post<ReturnApi>(this.Url + "/SaveInspectionSQE", item, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    SaveInspection_FG(item: FGInspectionModel): Observable<ReturnApi> {
        return this.http.post<ReturnApi>(this.Url + "/AddInspectionFgH", item, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetRepackingList(item: RepackingSearch): Observable<Array<RepackingList>> {
        return this.http.post<Array<RepackingList>>(this.Url + "/GetRepackingList", item, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetRepacking(PackingId: number): Observable<RepackingModel> {
        return this.http.get<RepackingModel>(this.Url + "/GetRepacking/" + PackingId.toString(), httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }


    SaveRePack(item: SplitBarCodeModel): Observable<ReturnApi> {
        return this.http.post<ReturnApi>(this.Url + "/SaveRePack", item, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    /** Log a ScgCompanyService message with the MessageService */
    private log(message: string) {
        console.log(message);
        // this.messageService.add('ScgCompanyService: ' + message);
    }


}


// WEBPACK FOOTER //
// ./src/app/services/inspection.service.ts